import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 13/11;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 13 10" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill={color} d="M3.365.385h8.76v1.23h-8.76V.385Zm0 4.98v-1.23h8.76v1.23h-8.76Zm0 3.75v-1.23h8.76v1.23h-8.76ZM1.49 7.555c.26 0 .482.095.667.285.186.19.278.41.278.66 0 .25-.095.467-.285.652a.918.918 0 0 1-1.312 0A.893.893 0 0 1 .56 8.5c0-.25.09-.47.27-.66.18-.19.4-.285.66-.285Zm0-7.5a.91.91 0 0 1 .667.277.91.91 0 0 1 .278.668c0 .26-.092.48-.278.66a.923.923 0 0 1-.667.27c-.26 0-.48-.09-.66-.27A.898.898 0 0 1 .56 1C.56.74.65.518.83.332c.18-.185.4-.277.66-.277Zm0 3.75a.91.91 0 0 1 .667.277.91.91 0 0 1 .278.668c0 .26-.092.48-.278.66a.923.923 0 0 1-.667.27c-.26 0-.48-.09-.66-.27a.898.898 0 0 1-.27-.66c0-.26.09-.482.27-.668.18-.185.4-.277.66-.277Z"/>
    </svg>
)

export default class IconList extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
